import { combineReducers } from 'redux';
import { connectRouter, LOCATION_CHANGE } from 'connected-react-router';

import breadcrumbReducer     from 'reducers/breadcrumbReducer';
import headerReducer         from 'reducers/headerReducer';
import loadingReducer        from 'reducers/loadingReducer';
import messageReducer        from 'reducers/messageReducer';
import payloadReducer        from 'reducers/payloadReducer';
import accountReducer        from 'reducers/accountReducer';
import programFileReducer    from 'reducers/programFileReducer';
import programSettingReducer from 'reducers/programSettingReducer';
import progressRateReducer   from 'reducers/progressRateReducer';

const defaultReducer = (state = {}, action) => {
  switch (action.type) {
    case LOCATION_CHANGE:
      return Object.assign({}, state, {});
    default:
      return state;
  }
};

export default (history) => combineReducers({
  router: connectRouter(history),         // Router の Reducer名は 'router' で決まっている
  defaultReducer,
  message: messageReducer,                // グローバルメッセージ
  breadcrumb: breadcrumbReducer,          // グローバルパンくずリスト情報
  loading: loadingReducer,                // グローバルローディングアイコン
  header: headerReducer,                  // グローバルヘッダー
  payload: payloadReducer,                // 各種ページコンテンツ
  account: accountReducer,                // 管理者アカウント情報
  programFile: programFileReducer,        // プログラムファイル情報
  programSetting: programSettingReducer,  // 調整プログラム設定情報
  progressRate: progressRateReducer,      // 更新／アップロード進捗率
});